import { Box, Collapse } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  open: boolean;
  children: ReactNode;
}

const useStyles = createUseStyles({
  accordion: {
    width: '100%',
  },
});

const Accordion: FC<Props> = ({ open, children }) => {
  const styles = useStyles();
  return (
    <Collapse in={open} timeout={200} className={styles.accordion}>
      <Box width="100%">{children}</Box>
    </Collapse>
  );
};

export default Accordion;
